export interface ForemanTimeSheet {
  foremanTimeSheetID: string;
  foremanJobID: string;
  workDate: Date;
  shift: number | null;
  foremanJobCrewID: string | null;
  fileID: string | null;
  fileName: string | null;
  customerFirstName: string | null;
  customerLastName: string | null;
  customerEmail: string | null;
  exceptions?: string | null;
  bActive: boolean;
  modifiedDate: Date | null;
}
